import { Command } from "@ckeditor/ckeditor5-core";

export default class ApplyNoBreakCommand extends Command {
  execute() {
    const editor = this.editor;
    const model = editor.model;

    model.change((writer) => {
      let selection = model.document.selection;
      const position = selection.getFirstPosition();

      if (position.findAncestor("nobreak")) {
        writer.unwrap(position.findAncestor("nobreak"));
      } else {
        // If the user has the cursor inside nobreak without having selected text
        if (selection.isCollapsed && position && position.textNode) {
          //Set the selection to the whole text node
          writer.setSelection(position.textNode, "on");
          selection = model.document.selection;
        }

        // Get all ranges in the selection
        // TODO: This should probably be passed through model.schema.getValidRanges, but that wasn't working
        const ranges = selection.getRanges();

        for (const range of ranges) {
          writer.wrap(range, "nobreak");
        }
      }
    });
  }

  refresh() {
    const model = this.editor.model;
    const selection = model.document.selection;

    const allowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      "$text",
    );

    this.isEnabled = selection && allowedIn !== null;
    this.isNoBreakOn = selection.getFirstPosition().findAncestor("nobreak");
  }
}
